module.exports = __webpack_public_path__ + "img/bg_d6f521f.png";